import type { Node } from 'prosemirror-model';

import { getHeadingIdForNode } from './headingLinksFromElements';

export const copyLink = async (
	node: Node,
	getHeadingLinkPath: () => string | null,
): Promise<boolean> => {
	try {
		const headingId = getHeadingIdForNode(node);
		if (!headingId) {
			return false;
		}

		const path = getHeadingLinkPath();

		if (!path) {
			return false;
		}

		const url = new URL(location.origin + path);

		url.hash = encodeURIComponent(headingId);
		const href = url.toString();

		if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
			await navigator.clipboard.writeText(href);
			return true;
		}

		return false;
	} catch {
		return false;
	}
};
